import { GET_DATA_MENU_ROLES_SUCCEEDED, REQUERT_MENU_ROLES_FAILED } from "../actions/actionTypes";


const menuRoleReducer = (DataMenuRoles = [], actions) =>{
    switch (actions.type) {
        case GET_DATA_MENU_ROLES_SUCCEEDED:
            if(Object.keys(actions.DataMenuRoles).length > 0){
                return {...DataMenuRoles, DataMenuRoles: actions.DataMenuRoles };
            }
            else{
                return {...DataMenuRoles, DataMenuRoles: []};
            }
        case REQUERT_MENU_ROLES_FAILED:
            return {...DataMenuRoles, DataMenuRoles: []};
        default:
            return DataMenuRoles;
    }
}
export default menuRoleReducer;